import { render, staticRenderFns } from "./ResumenVentas.vue?vue&type=template&id=53afa83b&"
import script from "./ResumenVentas.vue?vue&type=script&lang=js&"
export * from "./ResumenVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports